module.exports = __webpack_public_path__ + "img/logo-dark.305dfc35.png";